export default "__VITE_ASSET__B22YVze7__"